import axios from 'axios';
import {API_URL_PREFIX, axiosAuthHeader, axiosErrorHandler} from "./axios.utils";

const API_URL = API_URL_PREFIX + '/v1/comments';

class CommentsService {
    // no header needed
    getComments(entityId) {
        let url = API_URL + "?offset=0&limit=100&include_total=true&order_by=%2Dupdated_time&entity_id=" + entityId;
        return axios.get(url).catch(function (error) {
            axiosErrorHandler(error);
        });
    }

    // header required
    createComment(payload) {
        return axios.post(API_URL, payload, axiosAuthHeader()).catch(function (error) {
            axiosErrorHandler(error);
        });
    }
}

export default new CommentsService();
